<template>
  <div id="overview" class="margin-subpages">
    <div id="happyHouses">
      <div class="flex">
        <div class="sub-title">{{ $t("happilyVillage.HAPPILY_HOUSES") }}</div>
        <div class="ml-auto">
          <div style="widht: 140px">
            <div class="dropdown-sorting">
              <el-menu mode="horizontal">
                <el-submenu index="0" style="width: 140px">
                  <template slot="title">
                    <span class="text-dropdown" id="happilyHousesSorting">{{
                      $t("happilyVillage.THIS_WEEK")
                    }}</span>
                  </template>
                  <el-menu-item
                    @click="happilyHousesSorting('thisWeek')"
                    index="1"
                    class="is-active"
                    style="font-size: 14px; width: 220px"
                    >{{ $t("happilyVillage.This_Week") }}</el-menu-item
                  >
                  <el-menu-item
                    @click="happilyHousesSorting('thisMouth')"
                    index="2"
                    class="is-active"
                    style="font-size: 14px; width: 220px"
                    >{{ $t("happilyVillage.This_Month") }}</el-menu-item
                  >
                  <el-menu-item
                    @click="happilyHousesSorting('lastWeek')"
                    index="3"
                    class="is-active"
                    style="font-size: 14px; width: 220px"
                    >{{ $t("happilyVillage.Last_Week") }}</el-menu-item
                  >
                  <el-menu-item
                    @click="happilyHousesSorting('lastMouth')"
                    index="4"
                    class="is-active"
                    style="font-size: 14px; width: 220px"
                    >{{ $t("happilyVillage.Last_Month") }}</el-menu-item
                  >
                  <el-menu-item
                    @click="happilyHousesSorting('allTime')"
                    index="5"
                    class="is-active"
                    style="font-size: 14px; width: 220px"
                    >{{ $t("happilyVillage.All_time") }}</el-menu-item
                  >
                </el-submenu>
              </el-menu>
            </div>
          </div>
        </div>
      </div>
      <div class="line-style mt-16 mb-20" />
      <div class="flex mb-2">
        <div class="first-column mt-10 pt-40">
          <div
            v-for="(house, index) in houses"
            :key="house.key"
            class="flex-center ml-24 mb-12"
            style="width: 370px"
          >
            <div class="fw-700 fs-30 opa-03 mr-24">{{ index + 1 }}</div>
            <div class="flex-mid">
              <img
                v-if="house.house_name === 'Delphinus'"
                :alt="house.house_name"
                src="../../assets/images/happilyvillage/Delphinus_32@2x.png"
                class="image-skeleton image-profile-60 flex-mid mr-12"
              />
              <img
                v-else-if="house.house_name === 'Corvus'"
                :alt="house.house_name"
                src="../../assets/images/happilyvillage/Corvus_32@2x.png"
                class="image-skeleton image-profile-60 flex-mid mr-12"
              />
              <img
                v-else
                :alt="house.house_name"
                src="../../assets/images/happilyvillage/Leonos_32@2x.png"
                class="image-skeleton image-profile-60 flex-mid mr-12"
              />
            </div>
            <div class="flex-column">
              <div class="fc-4a4a4a fw-900">{{ house.house_name }}</div>
              <div class="fc-000000 fs-14 opa-05 mt-3">
                {{ $t("happilyVillage.Level") }} {{ house.level }}
              </div>
            </div>
            <div class="ml-auto mr-20">
              <div class="fc-000000 opa-08 fs-14 fw-700">
                {{
                  $utils("addCommasInNumber", renderMembers(house.key))
                }}
                active
              </div>
              <div class="fc-000000 fs-14 mt-3">
                <span
                  class="fc-32C2D5 fs-12 opa-05 cursor-pointer"
                  @click="showingMembersOfHouse(house)"
                >
                  {{ $utils("addCommasInNumber", house.members) }}
                  {{ $t("happilyVillage.total_members") }}
                </span>
              </div>
            </div>
          </div>
          <div v-if="houses.length === 0">
            <div
              v-for="index in [1, 2, 3]"
              :key="index"
              class="flex-center ml-24 mb-12"
            >
              <div class="fw-700 fs-30 opa-03 mr-24">{{ index }}</div>
              <div class="flex-mid">
                <div
                  class="image image-profile-60 flex-mid mr-12 text-skeleton"
                ></div>
              </div>
              <div class="flex-column">
                <div
                  class="fc-4a4a4a text-skeleton fw-900"
                  style="width: 180px"
                >
                  &nbsp;
                </div>
                <div
                  class="fc-000000 text-skeleton fs-14 mt-3"
                  style="width: 160px"
                >
                  &nbsp;
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="houses.length === 0 || !Object.keys(housesfilter).length"
          class="second-column flex pt-22 pb-22 pr-24"
        >
          <div class="data-card text-skeleton">&nbsp;</div>
          <div class="data-card text-skeleton">&nbsp;</div>
          <div class="data-card text-skeleton">&nbsp;</div>
        </div>
        <div v-else class="second-column flex pt-22 pb-22 pr-24">
          <div class="data-card green">
            <div style="color: #23da8d" class="fs-14 fw-700 mb-13">
              +{{ $t("happilyVillage.House_XP") }}
            </div>
            <div v-for="(house, index) in houses" :key="house.house_name">
              <div :class="`fw-500 fs-14 opa-08 ${index > 0 ? 'mt-36' : ''}`">
                +{{ $utils("addCommasInNumber", renderXP(house.key)) }} XP
              </div>
              <div class="fc-000000 fs-12 opa-05 mt-3">
                +{{
                  $utils(
                    "addCommasInNumber",
                    renderXPPerPerson(house.key, house.members)
                  )
                }}
                / {{ $t("happilyVillage.person") }}
              </div>
            </div>
          </div>
          <div class="data-card orange">
            <div style="color: #ef8011" class="fs-14 fw-700 mb-13">
              +{{ $t("happilyVillage.Distance") }}
            </div>
            <div v-for="(house, index) in houses" :key="house.house_name">
              <div :class="`fw-500 fs-14 opa-08 ${index > 0 ? 'mt-36' : ''}`">
                +{{ $utils("addCommasInNumber", renderDistance(house.key)) }}
                {{ $t("happilyVillage.km") }}
              </div>
              <div class="fc-000000 fs-12 opa-05 mt-3">
                +{{
                  $utils(
                    "addCommasInNumber",
                    renderDistancePerPerson(house.key, house.members)
                  )
                }}
                {{ $t("happilyVillage.km_per_person") }}
              </div>
            </div>
          </div>
          <div class="data-card red">
            <div
              style="color: #ef115e; width: 130px"
              class="fs-14 fw-700 mb-13"
            >
              +{{ $t("happilyVillage.Mission_Entries") }}
            </div>
            <div v-for="(house, index) in houses" :key="house.house_name">
              <div :class="`fw-500 fs-14 opa-08 ${index > 0 ? 'mt-36' : ''}`">
                +{{ $utils("addCommasInNumber", renderEntry(house.key)) }}
                {{ $t("happilyVillage.entries") }}
              </div>
              <div class="fc-000000 fs-12 opa-05 mt-3">
                {{
                  $utils("addCommasInNumber", renderParticipation(house.key))
                }}
                {{ $t("happilyVillage.participation") }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="grid-2-50">
      <div id="university" class="mt-28 mr-12">
        <div class="sub-title">{{ $t("happilyVillage.university") }}</div>
        <div class="line-style mt-16 mb-20" />
        <div class="gray-background px-20">
          <div
            class="ml-auto"
            style="width: 20px; margin-bottom: -18px; opacity: 0.52"
          >
            <el-tooltip effect="dark" placement="left">
              <div class="tooltipHelpStyle" slot="content">
                {{ $t("happilyVillage.A_count_of_how_many_learning") }}
              </div>
              <div clss="flex-center" style="padding-left: 8px">
                <img :src="getImgUrl('help_outline-16px')" />
              </div>
            </el-tooltip>
          </div>
          <div class="text-header-graph">
            <span class="fw-900">{{
              $utils("addCommasInNumber", university_total)
            }}</span>
            {{ $t("happilyVillage.Learning_and_Activity") }}
          </div>
          <div v-if="universityChartStatus" class="absolute-mid">
            <loading-even></loading-even>
          </div>
          <canvas
            ref="universityBarchart"
            height="120px"
            class="barchartStyle"
          ></canvas>
        </div>
        <div class="ml-auto mt-8" style="width: 60px">
          <span class="see-more" @click="goTo('university')">{{
            $t("happilyVillage.See_more")
          }}</span>
        </div>
      </div>
      <div id="townHall" class="mt-28 ml-12">
        <div class="sub-title">{{ $t("happilyVillage.town_hall") }}</div>
        <div class="line-style mt-16 mb-20" />
        <div class="gray-background px-20">
          <div
            class="ml-auto"
            style="width: 20px; margin-bottom: -18px; opacity: 0.52"
          >
            <el-tooltip effect="dark" placement="left">
              <div class="tooltipHelpStyle" slot="content">
                {{ $t("happilyVillage.A_count_of_how_many_comments") }}
              </div>
              <div clss="flex-center" style="padding-left: 8px">
                <img :src="getImgUrl('help_outline-16px')" />
              </div>
            </el-tooltip>
          </div>
          <div class="text-header-graph">
            <span class="fw-900">{{
              $utils("addCommasInNumber", townhall_total)
            }}</span>
            {{ $t("happilyVillage.Knowledge_Sharing_Interactions") }}
          </div>
          <div v-if="townHallChartStatus" class="absolute-mid">
            <loading-even></loading-even>
          </div>
          <canvas
            ref="townHallBarchart"
            height="120px"
            class="barchartStyle"
          ></canvas>
        </div>
        <div class="ml-auto mt-8" style="width: 60px">
          <span class="see-more" @click="goTo('townHall')">{{
            $t("happilyVillage.See_more")
          }}</span>
        </div>
      </div>
      <div id="runningTrack" class="mt-28 mr-12">
        <div class="sub-title">{{ $t("happilyVillage.running_track") }}</div>
        <div class="line-style mt-16 mb-20" />
        <div class="gray-background px-20">
          <div
            class="ml-auto"
            style="width: 20px; margin-bottom: -18px; opacity: 0.52"
          >
            <el-tooltip effect="dark" placement="left">
              <div class="tooltipHelpStyle" slot="content">
                {{ $t("happilyVillage.A_count_of_distance_traveled") }}
              </div>
              <div clss="flex-center" style="padding-left: 8px">
                <img :src="getImgUrl('help_outline-16px')" />
              </div>
            </el-tooltip>
          </div>
          <div class="text-header-graph">
            <span class="fw-900">{{
              $utils("addCommasInNumber", distance_all)
            }}</span>
            {{ $t("happilyVillage.km_Distance_Traveled") }}
          </div>
          <div v-if="runningTrackChartStatus" class="absolute-mid">
            <loading-even></loading-even>
          </div>
          <canvas
            ref="runningTrackBarchart"
            height="120px"
            class="barchartStyle"
          ></canvas>
        </div>
        <div class="ml-auto mt-8" style="width: 60px">
          <span class="see-more" @click="goTo('runningTrack')">{{
            $t("happilyVillage.See_more")
          }}</span>
        </div>
      </div>
      <div id="battleStadium" class="mt-28 mr-12">
        <div class="sub-title">{{ $t("happilyVillage.BATTLE_STADIUM") }}</div>
        <div class="line-style mt-16 mb-20" />
        <div class="gray-background px-20">
          <div
            class="ml-auto"
            style="width: 20px; margin-bottom: -18px; opacity: 0.52"
          >
            <el-tooltip effect="dark" placement="left">
              <div class="tooltipHelpStyle" slot="content">
                {{ $t("happilyVillage.A_count_of_how_many_entries") }}
              </div>
              <div clss="flex-center" style="padding-left: 8px">
                <img :src="getImgUrl('help_outline-16px')" />
              </div>
            </el-tooltip>
          </div>
          <div class="text-header-graph">
            <span class="fw-900">{{
              $utils("addCommasInNumber", missionEntry)
            }}</span>
            {{ $t("happilyVillage.Mission_Entries") }}
          </div>
          <div v-if="battleStadiumChartStatus" class="absolute-mid">
            <loading-even></loading-even>
          </div>
          <canvas
            ref="battleStadiumchart"
            height="120px"
            class="barchartStyle"
          ></canvas>
        </div>
        <div class="ml-auto mt-8" style="width: 60px">
          <span class="see-more" @click="goTo('battleStadium')">{{
            $t("happilyVillage.See_more")
          }}</span>
        </div>
      </div>
    </div>

    <el-dialog :visible.sync="dialogHouseMembers" top="8vh">
      <div class="recipients-modal">
        <div>
          <span class="fs-20 fw-700 fc-000000"
            >{{ $t("happilyVillage.House_of") }}
            {{ dialogHouseMembersTitle }}</span
          >
        </div>
        <div class="mt-24">
          <span class="fs-18 fw-700 fc-000000"
            >{{ $utils("addCommasInNumber", members.length) }}
            {{ $t("happilyVillage.members") }}</span
          >
        </div>
        <div class="mt-4">
          <span class="fc-626262 fs-14"
            >{{ $t("happilyVillage.making_up") }}
            {{ $utils("addCommasInNumber", this.population) }}%
            {{ $t("happilyVillage.of_Happily_Village") }}</span
          >
        </div>
      </div>
      <div class="members-recipients thin-scrollbar">
        <div v-for="item in members" :key="item.email" class="rowDataStyle">
          <div class="columnDataStyle" style="width: 100%">
            <div class="flex-center py-7">
              <div v-if="item.image">
                <img
                  v-lazy="item.image"
                  :key="item.image"
                  class="image-skeleton image-profile-42 flex-mid mr-16"
                  :class="[ blurMode ?  'blurelement': '' ]"
                />
              </div>
              <div v-else class="image image-profile-42 flex-mid mr-12"
              :class="[ blurMode ?  'blurelement': '' ]">
                <div
                  class="flex-mid text-in-image text-in-image-42"
                  style="width: 42px"
                >
                  {{
                    $utils("acronymName", {
                      firstName: item.firstname,
                      lastName: item.lastname,
                    })
                  }}
                </div>
              </div>
              <div class="flex-column pl-4">
                <span class="text-name"
                :class="[ blurMode ?  'blurelement': '' ]" style="width: 200px"
                  >{{ item.firstname }} {{ item.lastname }}</span
                >
                <span class="text-email"
                :class="[ blurMode ?  'blurelement': '' ]" style="width: 200px">{{
                  item.email
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Chart from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";
Chart.defaults.set('plugins.datalabels', {
  anchor: "end",
  align: "end",
  clamp: true,
  offset: 0,
  display: function(context) {
    return context.dataset.data[context.dataIndex] != 0;
  },
});
import _ from "lodash";

export default {
  name: "overview",
  components: {
    loadingEven: require("../even/loading").default,
  },
  created() {
    this.$store.dispatch("happilyvillage/getDataHouse");
    this.universityChartStatus = true;
    this.townHallChartStatus = true;
    this.runningTrackChartStatus = true;
    this.battleStadiumChartStatus = true;
    this.$store.dispatch("happilyvillageUniversity/getUniversity").then(() => {
      this.randerBarChartUniversity();
    });
    this.$store.dispatch("happilyvillageTownhall/getTownhall").then(() => {
      this.randerBarChartTownhall();
    });
    this.$store.dispatch("happilyvillage/getDataRunningTrack").then(() => {
      this.randerBarChartRunnigtrack();
    });
    this.$store
      .dispatch("happilyvillageBattleStadium/getMisiionUser")
      .then(() => {
        this.randerBarChartBattleStadium();
      });
  },
  computed: {
    activeUsers() {
      return this.$store.getters["happilyvillage/activeUsers"];
    },
    houses() {
      return this.$store.getters["happilyvillage/houses"];
    },
    housesfilter() {
      return this.$store.getters["happilyvillage/housesfilter"];
    },
    university() {
      return this.$store.getters["happilyvillageUniversity/university"];
    },
    university_graphmonth() {
      return this.$store.getters[
        "happilyvillageUniversity/university_graphmonth"
      ];
    },
    university_total() {
      return this.$store.getters["happilyvillageUniversity/university_total"];
    },
    townhall_graphmonth() {
      return this.$store.getters["happilyvillageTownhall/townhall_graphmonth"];
    },
    townhall_total() {
      return this.$store.getters["happilyvillageTownhall/townhall_total"];
    },

    distance_all() {
      return this.$store.getters["happilyvillage/distance_all"];
    },
    runningtrack_graphmonth() {
      return this.$store.getters["happilyvillage/runningtrack_graphmonth"];
    },
    members() {
      return this.$store.getters["happilyvillage/members"];
    },
    battleStadium_graphmonth() {
      return this.$store.getters["happilyvillageBattleStadium/missionChart6"];
    },
    missionEntry() {
      return this.$store.getters["happilyvillageBattleStadium/missionEntry"];
    },
    mission() {
      return this.$store.getters["happilyvillage/getMission"];
    },
    blurMode() {
      return this.$store.getters["demomode/blurMode"];
    },
  },
  data() {
    return {
      housesDropdown: "THIS WEEK",
      dialogHouseMembers: false,
      dialogHouseMembersTitle: null,
      universityChartStatus: false,
      townHallChartStatus: false,
      runningTrackChartStatus: false,
      battleStadiumChartStatus: false,
      population: 0,
      chartConfig: {
        scales: {
          x: {
            stacked: false,
            grid: {
              display: false,
            },
            categoryPercentage: 0.5,
            barPercentage: 1,
          },
          y: {
            stacked: false,
            ticks: {
              display: false,
              beginAtZero: true,
            },
            grid: {
              display: false,
              drawBorder: false,
            },
          },
        },
        layout: {
          padding: {
            top: 12,
          },
        },
      },
    };
  },
  methods: {
    renderXPPerPerson(key, members) {
      if (
        this.housesfilter &&
        this.housesfilter[key] !== undefined &&
        this.housesfilter[key].xp !== undefined &&
        members
      ) {
        return (this.housesfilter[key].xp / members).toFixed(2);
      }
      return 0;
    },
    renderXP(key) {
      if (
        this.housesfilter &&
        this.housesfilter[key] !== undefined &&
        this.housesfilter[key].xp !== undefined
      ) {
        return this.housesfilter[key].xp;
      }
      return 0;
    },
    renderDistancePerPerson(key, members) {
      if (
        this.housesfilter &&
        this.housesfilter[key] !== undefined &&
        this.housesfilter[key].distance &&
        members
      ) {
        return (this.housesfilter[key].distance / 1000 / members).toFixed(2);
      }
      return 0;
    },
    renderDistance(key) {
      if (
        this.housesfilter &&
        this.housesfilter[key] !== undefined &&
        this.housesfilter[key].distance
      ) {
        return (this.housesfilter[key].distance / 1000).toFixed(2);
      }
      return 0;
    },
    renderMembers(key) {
      if (this.activeUsers && this.activeUsers[key] !== undefined) {
        return this.activeUsers[key];
      }
      return 0;
    },
    renderEntry(key) {
      if (this.mission && this.mission[key] !== undefined) {
        return this.mission[key].entry;
      }
      return 0;
    },
    renderParticipation(key) {
      if (this.mission && this.mission[key] !== undefined) {
        return this.mission[key].participation;
      }
      return 0;
    },
    tableHouses(value) {
      this.housesDropdown = value;
      this.$store.dispatch("happilyvillage/getDataHouseFilter", value);
    },
    randerBarChartUniversity() {
      var universityBarchart = this.$refs.universityBarchart;
      const { university_graphmonth } = this;
      const month = [];
      const value = [];
      for (const x in university_graphmonth) {
        month.push(university_graphmonth[x].month);
        value.push(university_graphmonth[x].value);
      }
      // Reverse the arrays to show oldest months first
      month.reverse();
      value.reverse();

      if (universityBarchart) {
        this.universityChartStatus = false;
        const universityBarChartData = {
          labels: month,
          datasets: [
            {
              label: "Learning Interactions",
              data: value,
              backgroundColor: "#d6c3eb",
              borderColor: "#6C30CC",
              borderWidth: 1,
              datalabels: {
                color: "#6C30CC",
              },
            },
          ],
        };
        const options = JSON.parse(JSON.stringify(this.variable.chartOptioins));
        options.scales = this.chartConfig.scales;
        options.layout = this.chartConfig.layout;
        options.plugins.tooltip = {
          enabled: false,
        };
        this.universityBarchart = new Chart(
          universityBarchart.getContext("2d"),
          {
            plugins: [ChartDataLabels],
            type: "bar",
            data: universityBarChartData,
            options: options,
          }
        );
      }
    },
    randerBarChartTownhall() {
      var townHallBarchart = this.$refs.townHallBarchart;
      const { townhall_graphmonth } = this;
      const month = [];
      const value = [];
      for (const x in townhall_graphmonth) {
        month.push(townhall_graphmonth[x].month);
        value.push(townhall_graphmonth[x].value);
      }
      // Reverse the arrays to show oldest months first
      month.reverse();
      value.reverse();

      if (townHallBarchart) {
        this.townHallChartStatus = false;
        const townHallBarChartData = {
          labels: month,
          datasets: [
            {
              label: "Learning Interactions",
              data: value,
              backgroundColor: "#c3ebe9",
              borderColor: "#11A1B4",
              borderWidth: 1,
              datalabels: {
                color: "#11A1B4",
              },
            },
          ],
        };
        const options = JSON.parse(JSON.stringify(this.variable.chartOptioins));
        options.scales = this.chartConfig.scales;
        options.layout = this.chartConfig.layout;
        options.plugins.tooltip = {
          enabled: false,
        };
        this.townHallBarchart = new Chart(townHallBarchart.getContext("2d"), {
          plugins: [ChartDataLabels],
          type: "bar",
          data: townHallBarChartData,
          options: options,
        });
      }
    },
    randerBarChartRunnigtrack() {
      var runningTrackBarchart = this.$refs.runningTrackBarchart;
      const { runningtrack_graphmonth } = this;
      const month = [];
      const value = [];
      for (const x in runningtrack_graphmonth) {
        month.push(runningtrack_graphmonth[x].month);
        value.push(runningtrack_graphmonth[x].value);
      }
      // Reverse the arrays to show oldest months first
      month.reverse();
      value.reverse();

      if (runningTrackBarchart) {
        this.runningTrackChartStatus = false;
        const runningTarckBarChartData = {
          labels: month,
          datasets: [
            {
              label: "Learning Interactions",
              data: value,
              backgroundColor: "#f7d8ba",
              borderColor: "#EF8011",
              borderWidth: 1,
              datalabels: {
                color: "#EF8011",
                display: function(context) {
                  return context.dataset.data[context.dataIndex] != 0;
                },
              },
            },
          ],
        };
        const options = JSON.parse(JSON.stringify(this.variable.chartOptioins));
        options.scales = this.chartConfig.scales;
        options.layout = this.chartConfig.layout;
        options.plugins.tooltip = {
          enabled: false,
        };
        this.runningTrackBarchart = new Chart(
          runningTrackBarchart.getContext("2d"),
          {
            plugins: [ChartDataLabels],
            type: "bar",
            data: runningTarckBarChartData,
            options: options,
          }
        );
      }
    },
    randerBarChartBattleStadium() {
      var battleStadiumchart = this.$refs.battleStadiumchart;
      const month = [];
      const value = [];
      for (const x in this.battleStadium_graphmonth) {
        month.push(this.battleStadium_graphmonth[x].month);
        value.push(this.battleStadium_graphmonth[x].value);
      }
      // Reverse the arrays to show oldest months first
      month.reverse();
      value.reverse();

      if (battleStadiumchart) {
        this.battleStadiumChartStatus = false;
        const battleStadiumBarChartData = {
          labels: month,
          datasets: [
            {
              label: "",
              data: value,
              backgroundColor: "#EF115E46",
              borderColor: "#EF115E",
              borderWidth: 1,
              datalabels: {
                color: "#EF115E",
                display: function(context) {
                  return context.dataset.data[context.dataIndex] != 0;
                },
              },
            },
          ],
        };
        const options = JSON.parse(JSON.stringify(this.variable.chartOptioins));
        // options.scales = this.chartConfig.scales;
        // options.layout = this.chartConfig.layout;
        options.plugins.tooltip = {
          enabled: false,
        };
        this.battleStadiumBarChart = new Chart(
          battleStadiumchart.getContext("2d"),
          {
            plugins: [ChartDataLabels],
            type: "bar",
            data: battleStadiumBarChartData,
            options: options,
          }
        );
      }
    },
    getImgUrl(pic) {
      var images = require.context("../../assets/images/", false, /\.png$/);
      return images("./" + pic + ".png");
    },
    happilyHousesSorting(type) {
      if (type == "thisWeek") {
        document.getElementById("happilyHousesSorting").innerHTML = "THIS WEEK";
      } else if (type == "thisMouth") {
        document.getElementById("happilyHousesSorting").innerHTML =
          "THIS MONTH";
      } else if (type == "lastWeek") {
        document.getElementById("happilyHousesSorting").innerHTML = "LAST WEEK";
      } else if (type == "lastMouth") {
        document.getElementById("happilyHousesSorting").innerHTML =
          "LAST MONTH";
      } else if (type == "allTime") {
        document.getElementById("happilyHousesSorting").innerHTML = "ALL-TIME";
      }
      this.tableHouses(
        document.getElementById("happilyHousesSorting").innerHTML
      );
    },
    showingMembersOfHouse(house) {
      this.dialogHouseMembers = true;
      this.dialogHouseMembersTitle = house.house_name;
      this.population = house.population;
      this.$store.dispatch("happilyvillage/getDataHouseMember", house.key);
    },
    goTo(tab) {
      this.$emit("tabChanged", tab);
    },
  },
};
</script>

<style lang="scss" scoped>
.first-column,
.second-column {
  width: 100%;
  margin-right: auto;
}
.first-column {
  min-width: 300px;
  margin-right: 36px;
  max-width: 400px;
}
.second-column {
  max-width: 522px;
}
.grid-2 {
  display: grid;
  grid-template-columns: auto 100px;
}
.tooltipHelpStyle {
  width: 218px;
}
.text-header-graph {
  margin-bottom: 21px;
  margin-left: 8px;
  font-size: 16px;
  font-weight: 700;
}
.members-recipients {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 12px 0 0;
  margin: 0 0 0 16px;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 55vh;
}
.recipients-modal {
  padding-left: 40px;
  padding-bottom: 16px;
  margin-top: -20px;
  margin-left: -20px;
  margin-right: -20px;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 6px 6px #00000014;
  opacity: 1;
}
.see-more {
  color: #32c2d5;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
}
.dropdown-sorting {
  position: absolute;
  right: 40px;
  top: 13px;
}
.data-card {
  border: 1px solid rgb(216, 216, 216);
  padding: 9px 16px;
  border-radius: 16px;
  margin: 0 auto;
  width: calc((134px - (16px * 2)) - 2px);
}
.data-card.green {
  border-color: #23da8d;
  background-color: #23da8d0d;
}
.data-card.orange {
  border-color: #ef8011;
  background-color: #ef80110d;
}
.data-card.red {
  border-color: #ef115e;
  background-color: #ef115e0d;
}
.gray-background {
  border-radius: 24px;
  background-color: rgba(0, 0, 0, 0.03);
  position: relative;
  padding-top: 24px;
  padding-bottom: 20px;
}

.barchartStyle {
  border-radius: 4px;
  max-height: 134px;
}
</style>

<style>
#tabHeaderStyle .el-tabs__header {
  margin: 0 0 4px;
}
#overview .el-menu--horizontal > .el-submenu .el-submenu__title {
  color: #000000;
  font-weight: 700;
  font-size: 15px;
}
#overview .el-menu--horizontal > .el-submenu .el-submenu__icon-arrow {
  font-weight: 900;
}
#overview .el-menu.el-menu--horizontal {
  border: none;
  background-color: transparent;
}
#overview .el-dialog__body {
  padding-bottom: 8px;
}
</style>

